import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { AlertDetailSearchSchema } from './-constants';

export const Route = createFileRoute(
  '/_staff/accesses/_layout/alerts/detail/$shadowItAppId/',
)({
  validateSearch: zodValidator(AlertDetailSearchSchema),
});
